import * as React from 'react';
import { connect } from 'react-redux';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { POLICY_DETAILS, DASHBOARD, FNOL, CLAIM_HISTORY_V2 } from '../../routes/routes';
import { navigateTo } from '../../actions/navigationActions';
import { Image, Button, Accordion, Card } from 'react-bootstrap';
import { showDrivableNoModal } from '../../actions/modalActions';
import { showModalTraumaAssist, showModalAddAnotherClaim, showModalClaimAssistance } from '../../actions/modalCallbackActions';
import { COMPREHENSIVE_CAR_COVER_TYPE, AGREED_VALUE_COVER_TYPE, THIRDPARTY_CAR_COVER_TYPE, THIRDPARTY_FIRETHEFT_CAR_COVER_TYPE, THEFT_WRITEOFF_CAR_COVER_TYPE, CHILLI_CAR_COVER_TYPE, COMPREHENSIVE_MOTORBIKE_COVER_TYPE, THIRDPARTY_MOTORBIKE_COVER_TYPE, THIRDPARTY_THEFT_MOTORBIKE_COVER_TYPE, THEFT_MOTORBIKE_COVER_TYPE } from '../../constants/constants';
import { NAM_COUNTRY_ID } from '../../constants/internationalization';
import './ClaimInMeantime-and-EndInMeantime.css';

class ClaimEndPage extends React.Component<any, any> {

    constructor(props) {
        super(props);
        
        this.state = {
            roadSide0Open: false,
            roadSide1Open: false,
            roadSide2Open: false,
        }

        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleCoverRedirect = this.handleCoverRedirect.bind(this);
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    handleCallMeBack() {
        this.props.dispatchAction(showModalClaimAssistance());
    }

    handleCoverRedirect() {
        const isMobile = window.innerWidth <= 975;
        if (isMobile) {
            this.props.redirectTo(POLICY_DETAILS);
        }
    }

    handleRoadAccordianArrow(e: any) {
        switch (e) {
            case 0:
                this.setState({ roadSide0Open: !this.state.roadSide0Open })
                this.setState({ roadSide1Open: false, roadSide2Open: false, roadSide3Open: false, roadSide4Open: false, roadSide5Open: false, roadSide6Open: false })
                break;
            case 1:
                this.setState({ roadSide1Open: !this.state.roadSide1Open })
                this.setState({ roadSide0Open: false, roadSide2Open: false, roadSide3Open: false, roadSide4Open: false, roadSide5Open: false, roadSide6Open: false })
                break;
            case 2:
                this.setState({ roadSide2Open: !this.state.roadSide2Open })
                this.setState({ roadSide0Open: false, roadSide1Open: false, roadSide3Open: false, roadSide4Open: false, roadSide5Open: false, roadSide6Open: false })
                break;

            default:
        }
    }

    public render() {
        const isMobile = window.innerWidth <= 975;
        const { profile } = this.props;
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: FNOL, description: "Claims" }];

        let coverType = "Comprehensive cover on retail value";
        let coverNotice = "Please note...";
        let coverDescription: any = <></>;

        switch (this.props.claimSubmit.selectedRiskItem.productId.toUpperCase()) {
            case THEFT_WRITEOFF_CAR_COVER_TYPE: { coverType = "Motor theft and write off"; break; }
            case THIRDPARTY_CAR_COVER_TYPE: { coverType = "Third party"; break; }
            case THIRDPARTY_FIRETHEFT_CAR_COVER_TYPE: { coverType = "Third party fire and theft"; break; }
            case COMPREHENSIVE_CAR_COVER_TYPE: { coverType = "Comprehensive cover on retail value"; break; }
            case AGREED_VALUE_COVER_TYPE: { coverType = "Comprehensive cover on agreed value"; break; }
            case CHILLI_CAR_COVER_TYPE: { coverType = "Chilli"; break; }
            case COMPREHENSIVE_MOTORBIKE_COVER_TYPE: { coverType = "Comprehensive cover on agreed value"; break; }
            case THIRDPARTY_MOTORBIKE_COVER_TYPE: { coverType = "Third party"; break; }
            case THIRDPARTY_THEFT_MOTORBIKE_COVER_TYPE: { coverType = "Third party and theft"; break; }
            case THEFT_MOTORBIKE_COVER_TYPE: { coverType = "Theft"; break; }
        }

        switch (this.props.claimSubmit.selectedRiskItem.productId.toUpperCase()) {
            // Theft types
            case THEFT_MOTORBIKE_COVER_TYPE:
                break;
            case THEFT_WRITEOFF_CAR_COVER_TYPE: {
                coverDescription = <>
                    <p>Thing is, the cover that you selected and have been paying a premium for, covers you if your car is a write-off (uneconomical to repair). This means, that you’ll be responsible for any repairs, if your car is repairable.</p>
                    <p>If your car is repairable and there was another party involved that is responsible for the damage to your car, then you’re welcome to use our damage report to claim from them, their insurer or the small claims court.</p>
                    <p>Remember, if you or the insured driver damaged some 1’s property, and they contact you, you need to let our legal team know ASAP.</p>
                    <p>You can email them at <a className="font-weight-bold text-red" href="mailto:legal@kingprice.co.za" target="_blank">legal@kingprice.co.za</a>. Please don’t accept payments from the other party (or make them any offers) as this could influence our legal processes.</p>
                </>;
                break;
            }
            // Thirdparty types
            case THIRDPARTY_MOTORBIKE_COVER_TYPE:
            case THIRDPARTY_THEFT_MOTORBIKE_COVER_TYPE:
                coverNotice = "Sorry, we can’t process the claim for damage to your motorbike, but damage caused to someone else’s property is covered.";
                coverDescription = <>
                    <p>Thing is, the cover that you’ve selected and have been paying a premium for, doesn’t cover this type of damage.This means, you’ll be responsible for any repairs / replacements made to your motorbike. It does, however, cover other people’s damages.</p>
                    <p>Remember, if you or the insured rider damaged some 1’s property, and they contact you, you need to let our legal team know ASAP. You can email them at <a className="font-weight-bold text-red" href="mailto:legal@kingprice.co.za" target="_blank">legal@kingprice.co.za</a>. Please don’t accept payments from the other party (or make them any offers) as this could influence our legal processes.</p>
                    <p>If there was another party involved and they are responsible for the damages to your motorbike, then you’re welcome to use our damage report to claim from them, their insurer or the small claims court.</p>
                </>;
                break;
            case THIRDPARTY_CAR_COVER_TYPE:
            case THIRDPARTY_FIRETHEFT_CAR_COVER_TYPE: {
                coverNotice = "Sorry, we can’t process the claim for damage to your car, but damage caused to someone else’s property is covered.";
                coverDescription = <>
                    <p>Thing is, the cover that you’ve selected and have been paying a premium for, doesn’t cover this type of damage. This means, you’ll be responsible for any repairs / replacements made to your car. It does, however, cover other people’s damages.</p>
                    <p>Remember, if you or the insured driver damaged some 1’s property, and they contact you, you need to let our legal team know ASAP. You can email them at <a className="font-weight-bold text-red" href="mailto:legal@kingprice.co.za" target="_blank">legal@kingprice.co.za</a>. Please don’t accept payments from the other party (or make them any offers) as this could influence our legal processes.</p>
                    <p>If there was another party involved and they are responsible for the damages to your car, then you’re welcome to use our damage report to claim from them, their insurer or the small claims court.</p>
                </>;
                break;
            }
            // Comprehensive types (Comprehensive, Agreed value, Collectable & Chilli)
            case COMPREHENSIVE_CAR_COVER_TYPE:
            case AGREED_VALUE_COVER_TYPE:
            case CHILLI_CAR_COVER_TYPE:
            case COMPREHENSIVE_MOTORBIKE_COVER_TYPE:
            default: {
                coverDescription = <>
                    <p>Remember, if a third party’s property was damaged during this incident, then please don’t accept any payments from them or make them any offers, as this could influence our legal processes.</p>
                </>;
                break;
            }
        }

        return (
            <div id="ClaimEndPage" className="container-fluid new-page-margins claim-in-the-meantime-end">
                <div className="new-breadcrumbwrapper breadcrumb-wrapper-fnol-in-the-meantime-actual">
                    <KPBreadCrumb navList={BreadcrumbDetails} activePage="Submit a claim" />
                </div>
                {profile.personalPolicies[0] !== undefined &&
                    <div className="row new-page-main-row">
                        <div className="col-12 content-box-padding-20px fnol-dontforget-block fnol-cover-detail d-lg-none">
                            <h3>{coverNotice}</h3>
                            <div>
                                <p>Your cover type is <strong>{coverType}</strong>.</p>
                                {coverDescription}
                            </div>
                            <hr className="hr-minus20px" />
                            <div>
                                <span className="instruction">If this isn’t the cover that you selected on your policy...</span>
                                <button className="btn btn-outline-red btnResponsive pullright" onClick={() => this.handleCallMeBack()}>Request a callback</button>
                            </div>
                        </div>

                        <div className={"col-lg-4 col-12 fnol-inthemeantime-col-left" + (isMobile ? " px-0 " : "")}>
                            <div className="content-box-padding-20px fnol-inthemeantime-block-container">
                                <div className="fnol-inthemeantime-block-innercontainer">
                                    <h3>In the meantime</h3>
                                    <p className="pColor">Do you need assistance</p>
                                    <hr className="hr-minus20px" />
                                    <div className="submit-another-block fnol-inthemeantimeblocks" onClick={this.props.handleAnotherClaimModal}>
                                        <div className="row align-items-center">
                                            <div className="fnol-inthemeantimeblocks-icons align-self-center">
                                                <img src="./images/FNOL/submit-another-claim-46x46px.png" />
                                            </div>
                                            <div className="col fnol-inthemeantimeblocks-text align-self-center">
                                                Submit another claim relating to this incident
                                            </div>
                                            <div className="text-right align-self-center arrow-icons">
                                                <img src="./images/Claims/Dropdown-arrow-right-white.png" />
                                            </div>
                                        </div>
                                    </div>
                                    {this.props.profile.countryId !== NAM_COUNTRY_ID &&
                                        <div className="trauma-block fnol-inthemeantimeblocks" onClick={this.props.handleTraumaAssistModal}>
                                            <div className="row align-items-center cent-text">
                                                <div className="fnol-inthemeantimeblocks-icons align-self-center">
                                                    <img src="./images/Claims/heart-white.png" />
                                                </div>
                                                <div className="col fnol-inthemeantimeblocks-text align-self-center">
                                                    Trauma counselling
                                                </div>
                                                <div className="arrow-icons text-right align-self-center">
                                                    <img src="./images/Claims/Dropdown-arrow-right-white.png" />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="fnol-inthemeantime-col-gutter"></div>
                        <div className={"col fnol-inthemeantime-col-right" + (isMobile ? " px-0 " : "")}>

                        <div className="row noma">
                            <div className="col-12 content-box-padding-20px fnol-dontforget-block fnol-cover-detail d-none d-lg-block">
                                <h3>{coverNotice}</h3>
                                <div>
                                    <p>Your cover type is <strong>{coverType}</strong>.</p>
                                    {coverDescription}
                                </div>
                                <hr className="hr-minus20px" />
                                <div>
                                    <span className="instruction">If this isn’t the cover that you selected on your policy...</span>
                                    <button className="btn btn-outline-red btnResponsive pullright" onClick={this.handleCallMeBack}>Request a callback</button>
                                </div>
                            </div>

                            <div className="col-12 content-box-padding-20px-bottom-40px fnol-dontforget-block">
                                <h3>Don't forget to</h3>
                                <div className="fnol-dontforget-block-items-container">
                                    <div className="row align-items-center">
                                        <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-1.png" /></div>
                                        <div className="col align-self-center dont-forget-text">Report the incident to the <strong>police</strong> within 24 hours and <strong>get a police case number.</strong> </div>
                                    </div>
                                    <div className="row align-items-center">
                                        <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-2.png" /></div>
                                        <div className="col align-self-center dont-forget-text">
                                            <p className="dont-forget-text-actual">
                                                Get the <strong>details of any other party involved.</strong>
                                            </p>
                                            <span className="subtext">This applies if anyone else's property was damaged as a result of this incident.</span>
                                        </div>
                                    </div>
                                    <div className="row align-items-center">
                                        <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-3.png" /></div>
                                        <div className="col align-self-center dont-forget-text">Get details of anyone that <strong>witnessed the incident</strong> (if any).</div>
                                    </div>
                                    <div className="row align-items-center">
                                        <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-4.png" /></div>
                                        <div className="col align-self-center dont-forget-text">Get <strong> details of all passengers,</strong> if any were present. </div>
                                    </div>
                                    <div className="row align-items-center">
                                        <div className="dont-forget-icons"><img src="./images/Claims/dont-forget-5.png" /></div>
                                        <div className="col align-self-center dont-forget-text">Take pictures of the <strong>incident scene,</strong> the <strong>other vehicle involved</strong> in the incident, and the <strong>other driver's details.</strong></div>
                                    </div>
                                </div>
                                <button className="btn btn-outline-red" id="progress-button" onClick={() => this.handleRedirect(CLAIM_HISTORY_V2)}>View claim progress</button>
                            </div>

                            <div className='col-12 content-box-padding-20px-bottom-40px fnol-inthemeantime-faqs-block'>
                                <h3>FAQs</h3>
                                <div className="new-ssp-faq-block fnol-faq-block">
                                    <Accordion>
                                        <Card>
                                            <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => this.handleRoadAccordianArrow(0)}>
                                                <div className="row align-items-center">
                                                    <div className="col">
                                                        What if I didn't get the other driver’s details?
                                                    </div>
                                                    <div className={"accordion-arrow-svg" + (this.state.roadSide0Open != false ? ' isRotatednew' : '')}></div>
                                                </div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="0">
                                                <Card.Body>
                                                    <div className="text">
                                                        <p>Unfortunately, if you weren’t at fault, we won’t be able to assist you with the recovery of any costs. To get the other driver’s info, you can try checking with the police, tow truck operator, or the witnesses.</p>
                                                    </div>
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                        {this.props.profile.countryId !== NAM_COUNTRY_ID && <Card>
                                        <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => this.handleRoadAccordianArrow(1)}>
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    Who pays for the trauma counselling?
                                                </div>
                                                <div className={"accordion-arrow-svg" + (this.state.roadSide1Open != false ? ' isRotatednew' : '')}></div>
                                            </div>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="1">
                                            <Card.Body>
                                                <div className="text">
                                                    <p>King Price covers this cost. The counselling is done telephonically and there’s no limit on the number of sessions you can attend. However, if it’s determined that you need more in-depth, face-to-face sessions, Europ Assistance will refer you for further counselling, which will then be for your own account.</p>
                                                </div>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>}
                                    {this.props.profile.countryId !== NAM_COUNTRY_ID && <Card>
                                        <Accordion.Toggle as={Card.Header} eventKey="2" onClick={() => this.handleRoadAccordianArrow(2)}>
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    How does the trauma counselling work?
                                                </div>
                                                <div className={"accordion-arrow-svg" + (this.state.roadSide2Open != false ? ' isRotatednew' : '')}></div>
                                            </div>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="2">
                                            <Card.Body>
                                                <div className="text">
                                                    <ul>
                                                        <li>We send a request to Europ Assistance.</li>
                                                        <li>They then contact you, and provide the appropriate counselling.</li>
                                                        <li>During this call, the counsellor determines whether a follow-up call/counselling session is needed, or a face-to-face session (in this case they’ll refer you to a psychologist, which will be for your own account).</li>
                                                    </ul>
                                                </div>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>}
                                    </Accordion>
                                </div>
                                <div id="NeedHelp" className="content-box-padding-20px noshadow">
                                    <div className="row">
                                        <div className="col needhelp-whatsapp-left">
                                            <h3>Need help</h3>
                                            <p className="needhelp-call-you">We’ll call you back ASAP</p>
                                            <button className="btn btn-outline-red need-help-button" onClick={this.handleCallMeBack}>Call me back</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
        );
    }
}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        handleNotDrivableModal: () => dispatch(showDrivableNoModal()),
        handleAnotherClaimModal: () => dispatch(showModalAddAnotherClaim()),
        handleTraumaAssistModal: () => dispatch(showModalTraumaAssist()),
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimEndPage);